import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Viagem',
    path: '/transporte/traviagem',
    name: 'traviagem',
    component: () => import('@/views/transporte/traviagem/Index.vue'),
    meta: { permissions: [eTipoPermissao.VIAGEMNOVO_MENU_1100200199] },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Viagem',
    parent: 'traviagem',
    path: '/transporte/traviagem/cadastro/:id?',
    name: 'traviagem_create',
    component: () => import('@/views/transporte/traviagem/InclusaoEdicao.vue'),
    meta: { permissions: [eTipoPermissao.VIAGEMNOVO_MENU_1100200199] },
    goesToMenu: false,
  },
  {
    description: 'Usuários da Viagem',
    parent: 'traviagem',
    path: '/transporte/traviagem/:id/usuarios',
    name: 'traviagem_usuarios',
    component: () => import('@/views/transporte/traviagem/Usuarios.vue'),
    meta: { permissions: [eTipoPermissao.VIAGEMNOVO_MENU_1100200199] },
    goesToMenu: false,
  },
];
